import React, { useEffect, useState } from "react";
import "./Capas.css";
import { useParams } from "react-router-dom";
import { fetchNewsletterCovers } from "../../services/publicApi/PublicApi";
import ReactLoading from 'react-loading';

const Capas = () => {
  const { clientId, date } = useParams();
  const [coversCapas, setCoversCapas] = useState([]);
  const [brandCapas, setBrandCapas] = useState(null);
  const [loadingCapas, setLoadingCapas] = useState(false);

  const apiDate = date.replace(/-/g, "/");

  useEffect(() => {
    const carregarCapas = async () => {
      try {
        setLoadingCapas(true);

        const response = await fetchNewsletterCovers(clientId, apiDate);
        const coversArrayCapas = response?.covers?.covers || [];
        const brandUrlCapas = response?.covers?.brand || null;

        setCoversCapas(coversArrayCapas);
        setBrandCapas(brandUrlCapas);
      } catch (error) {
        console.error("Erro ao carregar capas:", error);
        setCoversCapas([]);
        setBrandCapas(null);
      } finally {
        setLoadingCapas(false);
      }
    };

    carregarCapas();
  }, [clientId, apiDate]);

  return (
    <div className="page-capas">
      <div className="page-inner-capas">
        <header className="header-capas">
          {brandCapas && (
            <div className="brand-wrapper-capas">
              <img
                src={brandCapas}
                alt="Marca do cliente"
                className="brand-img-capas"
              />
            </div>
          )}

          <div className="header-text-capas">
            <h1 className="titulo-capas">Capas do dia</h1>
            <p className="subtitle-capas">
              Clique em uma capa para abrir o PDF em uma nova aba.
            </p>
          </div>
        </header>

        {loadingCapas && (
            <div className="loading-overlay active">
            <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
            </div>
        )}

        {!loadingCapas && coversCapas.length === 0 && (
          <div className="status-wrapper-capas">
            <div className="status-pill-capas status-empty-capas">
              Nenhuma capa encontrada para esta data.
            </div>
          </div>
        )}

        {!loadingCapas && coversCapas.length > 0 && (
          <div className="grid-capas">
            {coversCapas.map((itemCapas) => (
              <div key={itemCapas.id} className="card-capas">
                <div className="card-inner-capas">
                  <div className="card-header-capas">
                    <span className="card-title-capas">{itemCapas.title}</span>
                  </div>

                  <a
                    href={itemCapas.document}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="thumb-link-capas"
                  >
                    <div className="thumb-wrapper-capas">
                      <img
                        src={itemCapas.thumbnail}
                        alt={itemCapas.title}
                        className="thumb-img-capas"
                      />
                      <div className="thumb-overlay-capas">
                        <span className="thumb-overlay-text-capas">
                          Abrir PDF
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Capas;
